// src/utils/cicloEscolar.js
// Ciclo administrativo (inscripciones, pagos, reportes): adelanta en noviembre
export const getCicloActual = () => {
  const hoy = new Date();
  const año = hoy.getFullYear();
  const mes = hoy.getMonth(); // 0 = enero

  // Noviembre (10) o diciembre (11) → ciclo del próximo año
  return mes >= 10 ? año + 1 : año;
};

export const getCicloAnterior = () => getCicloActual() - 1;

// Ciclo académico (actividades, notas, aula): cambia en enero
export const getCicloAcademico = () => new Date().getFullYear();

// Primer ciclo con notas en el sistema; los anteriores solo tienen inscripciones
const PRIMER_CICLO_CON_NOTAS = 2026;

// Años para los selectores: desde el primer ciclo del sistema hasta el siguiente (para adelantar),
// el más reciente primero. getCicloActual() (adelantado) siempre cae dentro del rango.
export const getAniosAcademicos = () => {
  const anios = [];
  for (let y = getCicloAcademico() + 1; y >= PRIMER_CICLO_CON_NOTAS; y--) anios.push(y);
  return anios;
};

// Ciclos distintos de una lista de inscripciones, el más reciente primero
export const ciclosDeInscripciones = (inscripciones) =>
  [...new Set(inscripciones.map(i => String(i.CicloEscolar)))]
    .filter(c => Number(c) >= PRIMER_CICLO_CON_NOTAS)
    .sort().reverse();

// Ciclo inicial de un selector: el académico si está en la lista, si no el más reciente
export const cicloInicial = (ciclos) => {
  const academico = String(getCicloAcademico());
  return ciclos.includes(academico) ? academico : ciclos[0];
};
